<template>
  <div class="index">
    <div
      v-if="lang && lang['homepage_new'] && pax.is_expired && pax.nps_option == '0' && isEnabledConfig('SFS_LANG_ROW_17')"
      class="container expired mb-4"
    >
      {{ lang['homepage_new'].SFS_LANG_ROW_17 }}
    </div>
    <div v-else-if="lang && lang['homepage_new'] && airline && pax" class="container">
      <div v-if="curPaxInfo" class="my-4">
        <router-link class="link-item-voucher" :to="{ name: 'PassengerDetail', query: { secret: secret } }">
          <ItemOfVouchers icon="contact-detail" color="#a7116f" :label="getNameCurPax" :pnr="getPNRCurPax" />
        </router-link>
      </div>
      <div class="my-4">
        <ListFlightInfo :flight-legs="flightLegs" />
      </div>
      <!--VOUCHERS-->
      <div class="mb-4">
        <div
          v-if="airline.lang_config && isEnabledConfig('SFS_LANG_ROW_4') && showServicesSection"
          class="title-voucher-and-service"
          :style="{ 'text-align': direction == 'rtl' ? 'right' : 'left' }"
        >
          {{ lang['homepage_new'].SFS_LANG_ROW_4 }}
        </div>
        <div v-if="airline.lang_config" class="mt-4">
          <!--REFRESHMENT-->
          <div v-if="CheckServices.refreshment">
            <div v-for="(refreshmentItem, index) in listRefreshmentArray" :key="index" class="mb-4">
              <router-link
                v-if="refreshmentItem.status != 2"
                class="link-item-voucher"
                :to="{ name: 'Refreshment', query: { secret: secret, refreshmentId: refreshmentItem.id } }"
              >
                <ItemOfVouchers
                  v-if="listRefreshmentSize > 1"
                  icon="refreshment-voucher"
                  color="#54ceae"
                  :label="lang['homepage_new'].SFS_LANG_ROW_5 + ` (${index + 1})`"
                  :used="
                    typeof refreshmentItem.bank_info != 'undefined' && refreshmentItem.bank_info.transfer_bank_info ? true : false
                  "
                />
                <ItemOfVouchers
                  v-else
                  icon="refreshment-voucher"
                  color="#54ceae"
                  :label="lang['homepage_new'].SFS_LANG_ROW_5"
                  :used="
                    typeof refreshmentItem.bank_info != 'undefined' && refreshmentItem.bank_info.transfer_bank_info ? true : false
                  "
                />
              </router-link>
            </div>
          </div>

          <div v-if="CheckServices.mealPlan && issuedHotel">
            <div class="mb-4">
              <router-link class="link-item-voucher" :to="{ name: 'MealPlan', query: { secret: secret } }">
                <ItemOfVouchers icon="meal-plan-voucher" color="#f5b945" :label="lang['homepage_new'].SFS_LANG_ROW_8" />
              </router-link>
            </div>
          </div>

          <!--HOTEL-->
          <div v-if="CheckServices.hotel && airline.params && airline.params.mobile_book_hotel">
            <div
              v-if="groupShareRoom.length == 0 && PaxsGroup.length > 1 && pax.has_cancelled_hotel_voucher"
              :class="{ disabled: pax.is_disabled_select_hotel }"
            >
              <div v-for="index in numberHotelRoom" :key="index" class="mb-4" @click="selectHotel(passenger[0])">
                <ItemOfHotelVouchers
                  icon="hotel-voucher"
                  color="#f0725e"
                  :label="lang['homepage_new'].SFS_LANG_ROW_6"
                  :is-handle-click="isHandleClickHotel"
                  :url="urlHotel"
                  :disable="!!pax.has_cancelled_hotel_voucher && !issuedHotel"
                />
              </div>
            </div>
            <div v-else-if="groupShareRoom.length == 0"
              :class="{ disabled: pax.is_disabled_select_hotel }"
            >
              <div class="mb-4" @click="selectHotel(nightPax[0])">
                <ItemOfHotelVouchers
                  icon="hotel-voucher"
                  color="#f0725e"
                  :label="getLabelByNightPax"
                  :is-handle-click="isHandleClickHotel"
                  :url="urlHotel"
                  :disable="!!pax.has_cancelled_hotel_voucher && !issuedHotel"
                  :label-ear-marker="getLabelEarMarker"
                  :is-show-ear="isShowEarByNightPax"
                />
              </div>
            </div>
            <div v-else>
              <div v-for="(group, index) in groupShareRoom" :key="index">
                <template v-if="group.night.length > 0">
                  <div class="mb-4">
                    <router-link
                      class="link-item-voucher"
                      :to="{
                        name: 'SelectRoom',
                        query: {
                          secret: secret,
                          voucher_id: group.night[0].voucher_id,
                          reservation_id: group.night[0].reservation_id,
                          pax_voucher_id: group.passenger_id
                        }
                      }"
                    >
                      <ItemOfHotelVouchers
                        icon="hotel-voucher"
                        color="#f0725e"
                        :label="getLabelByGroupNight[index]"
                        :is-show-ear="isShowEarByGroup[index]"
                        :label-ear-marker="getLabelEarMarker"
                      />
                    </router-link>
                  </div>
                </template>
                <template v-else>
                  <div class="mb-4">
                    <div class="link-item-voucher disable-service">
                      <ItemOfHotelVouchers
                        icon="hotel-voucher"
                        color="#f0725e"
                        :label="lang['homepage_new'].SFS_LANG_ROW_6"
                        disable
                      />
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!--TAXI-->
          <div v-if="CheckServices.taxi" class="mb-4">
            <div v-if="taxi && taxi.taxi_booking_detail && taxi.taxi_booking_detail.length > 0">
              <div v-for="(taxiDetail, index) in taxi.taxi_booking_detail" :key="index">
                <router-link
                  :is="taxi.params.has_cancelled_taxi_voucher == 1 ? 'div' : 'router-link'"
                  class="link-item-voucher"
                  :to="{ name: 'TaxiService', query: { secret: secret, indexBooking: index } }"
                >
                  <ItemOfVouchers
                    v-if="taxi.taxi_booking_detail.length > 1"
                    icon="taxi-voucher"
                    color="#56c3e0"
                    :label="lang['homepage_new'].SFS_LANG_ROW_7 + ` (${index + 1})`"
                    :used="typeof taxiDetail.bank_info != 'undefined' && taxiDetail.bank_info.transfer_bank_info ? true : false"
                    :disable="taxi.params.has_cancelled_taxi_voucher == 1"
                  />
                  <ItemOfVouchers
                    v-else
                    icon="taxi-voucher"
                    color="#56c3e0"
                    :label="lang['homepage_new'].SFS_LANG_ROW_7"
                    :used="typeof taxiDetail.bank_info != 'undefined' && taxiDetail.bank_info.transfer_bank_info ? true : false"
                    :disable="taxi.params.has_cancelled_taxi_voucher == 1"
                  />
                </router-link>
              </div>
            </div>
            <div v-else-if="taxiDetailBooking.length">
              <template v-if="taxiDetailBooking.length == 1">
                <div v-for="(booking, index) in taxiDetailBooking" :key="index">
                  <router-link
                    class="link-item-voucher"
                    :to="{ name: 'TaxiService', query: { secret: secret, indexBooking: index } }"
                  >
                    <ItemOfVouchers
                      icon="taxi-voucher"
                      color="#56c3e0"
                      :label="lang['homepage_new'].SFS_LANG_ROW_7"
                      :used="isUsedForTaxi2Ride"
                    />
                  </router-link>
                </div>
              </template>
              <template v-else>
                <div v-for="(booking, index) in mapTaxiDetailBooking" :key="index">
                  <router-link
                    class="link-item-voucher"
                    :to="{ name: 'TaxiService', query: { secret: secret, indexBooking: index } }"
                    :event="(typeof booking != 'undefined' && booking.karhoo_id) || isFirstTripCompleted ? 'click' : ''"
                    @click="showError()"
                  >
                    <ItemOfVouchers
                      icon="taxi-voucher"
                      color="#56c3e0"
                      :label="lang['homepage_new'].SFS_LANG_ROW_7 + ` (${index + 1})`"
                      :used="isUsedForTaxi2Ride"
                      :is-first-trip-completed="isFirstTripCompleted"
                      :taxi="true"
                      @click="listenClickVoucher(booking, index)"
                    />
                  </router-link>
                </div>
              </template>
            </div>
            <div v-else>
              <router-link class="link-item-voucher" :to="{ name: 'TaxiService', query: { secret: secret, indexBooking: 0 } }">
                <ItemOfVouchers
                  icon="taxi-voucher"
                  color="#56c3e0"
                  :label="lang['homepage_new'].SFS_LANG_ROW_7 || 'Taxi voucher'"
                  :used="isUsedP2CVoucher ? true : false"
                />
              </router-link>
            </div>
          </div>
          <!--MONETARY COMPENSATION-->
          <div v-if="CheckServices.monetary" class="mb-4">
            <div v-for="(monetary, index) in listMonetaryArray" :key="index">
              <router-link
                :is="monetary.status == 2 ? 'div' : 'router-link'"
                class="link-item-voucher"
                :to="
                  monetary.status == 2
                    ? {}
                    : {
                        name: 'MonetaryCompensationService',
                        query: { secret: secret, monetary_id: monetary.id, order_id: monetary.orders[0].id }
                      }
                "
              >
                <ItemOfVouchers
                  v-if="listMonetarySize > 1"
                  icon="monetary"
                  color="#bbe35d"
                  :label="lang['homepage_new'].SFS_LANG_ROW_9 + ` (${index + 1})`"
                  :used="(monetary.bank_info && monetary.bank_info.transfer_bank_info) || monetary.status == 3 ? true : false"
                  :disable="monetary.status == 2"
                />
                <ItemOfVouchers
                  v-else
                  icon="monetary"
                  color="#bbe35d"
                  :label="lang['homepage_new'].SFS_LANG_ROW_9"
                  :used="(monetary.bank_info && monetary.bank_info.transfer_bank_info) || monetary.status == 3 ? true : false"
                  :disable="monetary.status == 2"
                />
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!--SERVICES-->
      <div class="mb-4">
        <div
          v-if="airline.lang_config && isEnabledConfig('SFS_LANG_ROW_10') && showServicesSection"
          class="title-voucher-and-service"
        >
          {{ lang['homepage_new'].SFS_LANG_ROW_10 }}
        </div>
        <div class="mt-4">
          <!--MY DOCUMENT-->
          <div
            v-if="airline.lang_config && isEnabledConfig('SFS_LANG_ROW_11') && pax.document && pax.document.length > 0"
            class="mb-4"
          >
            <router-link class="link-item-voucher" :to="{ name: 'MyDocument', query: { secret: secret, isHome: true } }">
              <ItemOfVouchers icon="personal-documents" color="#0094d5" :label="lang['homepage_new'].SFS_LANG_ROW_11" />
            </router-link>
          </div>
          <!-- CALL BACK -->
          <div
            v-if="
              airline.params &&
              airline.params.enable_callback_function == 1 &&
              airline.params.enable_class &&
              airline.params.enable_class[pax.class] == 1 &&
              airline.params.enable_callback_function_class &&
              airline.params.enable_callback_function_class[pax.class] == 1 &&
              curPaxInfo &&
              curPaxInfo.is_call_back
            "
            class="mb-4"
          >
            <div v-if="curPaxInfo" @click="callBackPax()">
              <ItemOfVouchers
                icon="call"
                color="#0094d5"
                :label="replaceStr(lang['homepage_new'].SFS_LANG_ROW_12, ['<airline>'], airline.name)"
              />
            </div>
          </div>
          <!-- COMBINE VOUCHER -->
          <div v-if="airline.params && airline.params.mobile_enable_travelcompanions_home == 1" class="mb-4">
            <router-link
              :to="{ name: 'InviteTravelTogether', query: { secret: secret, isinviteurl: true } }"
              class="link-item-voucher"
            >
              <ItemOfVouchers icon="combine-voucher" color="#0094d5" :label="lang['homepage_new'].SFS_LANG_ROW_13" />
            </router-link>
          </div>
          <!-- DOWNLOAD VOUCHER -->
          <div v-if="airline.params && airline.params.disable_download_all_voucher != 1 && !isIEBrowser" class="mb-4">
            <router-link
              class="link-item-voucher"
              :to="{ name: 'DownloadAllVoucher', query: { secret: secret } }"
              target="_blank"
            >
              <ItemOfVouchers icon="download" color="#0094d5" :label="lang['homepage_new'].SFS_LANG_ROW_14" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <b-alert
      v-model="showAlertTop"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000; border-radius: 1rem !important; border: 1px solid #ffa5a5; color: #444"
      variant="danger"
      dismissible
    >
      <div>
        <div>{{ messagesError }}</div>
      </div>
    </b-alert>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import '@/assets/scss/modules/Home.scss'
import { replaceStr, empty } from '@/utils/helper'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'
import ItemOfHotelVouchers from '@/components/ItemOfHotelVouchers/index'
import ListFlightInfo from '@/components/ListFlightInfo/index'

export default {
  name: 'Home',
  components: { ItemOfVouchers, ListFlightInfo, ItemOfHotelVouchers },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      confirm: 0,
      bookHotelEnable: false,
      messageNumber: 1,
      hotelTitle: '',
      Refreshment: '',
      taxi: null,
      taxiDetailBooking: [],
      curPaxInfo: null,
      groupShareRoom: [],
      Hotel: '',
      showServicesSection: '',
      cancelMessage: '',
      issuedHotel: false,
      numberHotelRoom: 1,
      isIEBrowser:
        navigator.userAgent.indexOf('MSIE ') > -1 ||
        navigator.userAgent.indexOf('Trident/') > -1 ||
        navigator.userAgent.indexOf('Edge/') > -1,
      nightPax: [],
      completeTaxiKarhoo: false,
      isFirstTripCompleted: false,
      isHandleClickHotel: false,
      messagesError: '',
      showAlertTop: false,
      urlHotel: {
        path: '',
        query: {}
      },
      curPaxID: null
    }
  },
  computed: {
    ...mapGetters({
      Cmtpax: 'Home/Cmtpax',
      Services: 'Home/Services',
      CheckServices: 'Home/CheckServices',
      Flight: 'Flight/Flight',
      flightLegs: 'Flight/flightLegs',
      DataMsg: 'MessagesList/Cmtpax',
      PaxsGroup: 'Home/PaxsGroup',
      MonetaryService: 'Home/monetaryService',
      PaxsHotel: 'SelectRoom/PaxsHotel',
      TaxiVoucher: 'Taxi/Voucher'
    }),
    getNameCurPax() {
      if (this.curPaxInfo) {
        return `${this.curPaxInfo.first_name} ${this.curPaxInfo.last_name}`
      }
      return ''
    },
    getPNRCurPax() {
      if (this.curPaxInfo) {
        return `${this.curPaxInfo.pnr}`
      }
      return ''
    },
    showMultipleVouchers() {
      let self = this
      let curTaxiVoucher = self.checkCurTaxiVoucher()
      if (
        (!_.isEmpty(curTaxiVoucher) && !_.isUndefined(curTaxiVoucher.used_transfer_wise) && curTaxiVoucher.used_transfer_wise) ||
        ((self.isMobileSelfServiceP2C() || self.isTaxi2RideReject()) &&
          (_.isEmpty(curTaxiVoucher) || _.isUndefined(curTaxiVoucher.used_transfer_wise) || !curTaxiVoucher.karhoo_id))
      ) {
        return false
      }
      return true
    },
    isUsedForTaxi2Ride() {
      let self = this
      let taxi_booking = _.filter(self.taxiDetailBooking, (taxi) => {
        return _.isNull(taxi.karhoo_id)
      })
      if (taxi_booking.length == self.taxiDetailBooking.length) {
        //all were booked by p2c
        let paxId = self.pax.id
        if (self.PaxsGroup.length > 1) {
          //group passenger
          let matrix_share_taxi = self.getMatrixShareTaxi(self.taxi.params)
          //get voucher was used for this passenger's taxi
          let voucher = self.getPaxTaxiVoucher(matrix_share_taxi, paxId)
          if (!_.isNull(voucher) && !_.isUndefined(voucher) && voucher.used_transfer_wise == 1) {
            self.mapTaxiDetailBooking.splice(self.indexClickVoucher, 1)
            return true
          }
          return false
        } else {
          //single passenger
          let voucher = self.TaxiVoucher[paxId]
          if (!_.isNull(voucher) && !_.isUndefined(voucher) && voucher.used_transfer_wise == 1) {
            self.mapTaxiDetailBooking.splice(self.indexClickVoucher, 1)
            return true
          }
        }
      }
      return false
    },
    isUsedP2CVoucher() {
      let self = this
      if (empty(self.pax) || empty(self.PaxsGroup) || empty(self.taxi?.params) || empty(self.TaxiVoucher)) {
        return false
      }
      //current paxId
      let paxId = self.pax.id
      if (self.PaxsGroup.length > 1) {
        //group passenger
        let matrix_share_taxi = self.getMatrixShareTaxi(self.taxi.params)
        //get voucher was used for this passenger's taxi
        let voucher = self.getPaxTaxiVoucher(matrix_share_taxi, paxId)
        if (!_.isNull(voucher) && !_.isUndefined(voucher) && voucher.used_transfer_wise == 1) {
          return true
        }
        return false
      } else {
        //single passenger
        let voucher = self.TaxiVoucher[paxId]
        if (!_.isNull(voucher) && !_.isUndefined(voucher) && voucher.used_transfer_wise == 1) {
          return true
        }
      }
      return false
    },
    // list_refreshment có thể là array hoặc object
    listRefreshmentArray() {
      return _.toArray(this.Refreshment.list_refreshment)
    },
    listRefreshmentSize() {
      return _.size(this.Refreshment.list_refreshment)
    },
    listMonetaryArray() {
      let listMonetaryArray = this.MonetaryService.list_monetary.reduce((acc, obj) => ({ ...acc, [obj.voucher_code]: obj }), {})
      return _.toArray(listMonetaryArray)
    },
    listMonetarySize() {
      return _.size(this.listMonetaryArray)
    },
    getLabelByNightPax() {
      return this.nightPax[0] &&
        !this.nightPax[0].reservation_id &&
        !this.nightPax[0].voucher_id &&
        !this.pax.has_cancelled_hotel_voucher &&
        !this.issuedHotel
        ? this.lang['homepage_new'].SFS_LANG_ROW_27 || 'Select your hotel'
        : this.lang['homepage_new'].SFS_LANG_ROW_6
    },
    getLabelByGroupNight() {
      return this.groupShareRoom.map((group) =>
        group.night[0] &&
        !group.night[0].reservation_id &&
        !group.night[0].voucher_id &&
        !this.pax.has_cancelled_hotel_voucher &&
        !this.issuedHotel
          ? this.lang['homepage_new'].SFS_LANG_ROW_27 || 'Select your hotel'
          : this.lang['homepage_new'].SFS_LANG_ROW_6
      )
    },
    isShowEarByNightPax() {
      return (
        this.nightPax[0] &&
        !this.nightPax[0].reservation_id &&
        !this.nightPax[0].voucher_id &&
        !this.pax.has_cancelled_hotel_voucher &&
        !this.issuedHotel
      )
    },
    isShowEarByGroup() {
      return this.groupShareRoom.map(
        (group) =>
          group.night[0] &&
          !group.night[0].reservation_id &&
          !group.night[0].voucher_id &&
          !this.pax.has_cancelled_hotel_voucher &&
          !this.issuedHotel
      )
    },
    getLabelEarMarker() {
      if (!this.pax.is_disabled_select_hotel) {
        return this.lang['homepage_new'].SFS_LANG_ROW_28 || 'Select here'
      } else {
        return this.lang['homepage_new'].SFS_LANG_ROW_30 || 'Expired'
      }
    }
  },
  watch: {
    CheckServices: function () {
      this.showServicesSection = _.find(this.CheckServices, function (o) {
        return o === 1
      })
      if (this.CheckServices.refreshment) {
        this.Refreshment = _.find(this.Services, { service_id: 2 })
      }
      if (!_.isEmpty(this.lang) && !_.isUndefined(this.lang) && !_.isEmpty(this.PaxsGroup)) {
        this.generateHotelTitle()
      }
      if (this.CheckServices.taxi) {
        this.completeTaxiKarhoo = this.checkTaxiKarhooTrip()
        this.isFirstTripCompleted = this.checkFirstTripCompleted()
      }
    },
    lang: function () {
      if (!_.isEmpty(this.CheckServices) && !_.isEmpty(this.PaxsGroup)) {
        this.generateHotelTitle()
      }
    },
    PaxsGroup: function () {
      if (!_.isEmpty(this.pax)) {
        this.getPaxInfo()
      }
      if (!_.isEmpty(this.CheckServices) && !_.isEmpty(this.lang) && !_.isUndefined(this.lang)) {
        this.generateHotelTitle()
      }
    },
    pax: function () {
      if (!_.isEmpty(this.PaxsGroup)) {
        this.getPaxInfo()
      }
    },
    airline: function () {
      if (!_.isEmpty(this.PaxsGroup)) {
        this.getPaxInfo()
      }
    },
    PaxsHotel: function () {
      this.generateHotelTitle()
    },
    showAlertTop() {
      if (this.showAlertTop) {
        setTimeout(() => {
          this.showAlertTop = false
        }, 5000)
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    replaceStr,
    replaceMessage(v) {
      return v.substr(0, 20)
    },
    async initalData() {
      let self = this
      await Promise.all([
        this.$store.dispatch('Taxi/getTaxiVoucher'),
        this.$store.dispatch('Home/getCmtpax'),
        this.$store.dispatch('Home/getServices'),
        this.$store.dispatch('Flight/getFlight'),
        this.$store.dispatch('MessagesList/getCmtpax'),
        this.$store.dispatch('reGetPax'),
        this.$store.dispatch('Home/getPaxsGroup'),
        this.$store.dispatch('SelectRoom/getPaxsHotel')
      ])
      this.curPaxId = this.pax.id || this.pax.curPaxId

      if (!_.isEmpty(self.Services)) {
        self.taxi = _.find(self.Services, { service_id: 4 })
        if (!_.isEmpty(self.taxi)) {
          self.taxiDetailBooking =
            !_.isUndefined(self.taxi.taxi_booking_detail) && self.taxi.taxi_booking_detail ? self.taxi.taxi_booking_detail : []
        }
        self.checkNumberHotelRoom(self.Services)
      }
      self.mapTaxiDetailBooking = self.taxiDetailBooking
    },
    async init() {
      await this.initalData()
      if (!_.isEmpty(this.PaxsGroup) && !_.isEmpty(this.pax)) {
        this.getPaxInfo()
      }
    },
    checkCurTaxiVoucher() {
      let self = this
      if (_.isUndefined(self.taxi) && _.isEmpty(self.taxi)) {
        return null
      }
      let matrixShareTaxi =
        !_.isUndefined(self.taxi.params) &&
        !_.isEmpty(self.taxi.params) &&
        !_.isUndefined(self.taxi.params.matrix_share_taxi) &&
        !_.isEmpty(self.taxi.params.matrix_share_taxi)
          ? [...self.taxi.params.matrix_share_taxi]
          : []

      if (!matrixShareTaxi.length || !self.TaxiVoucher || _.isUndefined(self.curPaxId)) {
        return null
      }

      let paxGroup = _.find(matrixShareTaxi, function (group) {
        return _.indexOf(group, parseInt(self.curPaxId)) >= 0
      })
      let paxVoucher = Object.keys(self.TaxiVoucher)
      let indexVoucher = _.find(paxVoucher, function (paxId) {
        return _.indexOf(paxGroup, paxId.toString()) >= 0
      })

      return self.TaxiVoucher[indexVoucher]
    },
    isTaxi2RideReject() {
      let isReject = false
      if (!_.isEmpty(this.taxi) && !_.isEmpty(this.taxi.params)) {
        let attempt = this.taxi.params.times_attempts_to_connect_karhoo || 0
        let isAbort = this.taxi.params.is_abort || 0
        if (parseInt(attempt) === parseInt(this.airline.times_attempts_to_connect_karhoo) || isAbort) {
          isReject = true
        }
      }
      return isReject
    },
    isMobileSelfServiceP2C() {
      let self = this
      const mobile_self_service = _.get(self.airline, 'taxi_config.mobile_self_service')
      return mobile_self_service == 'photo2claim'
    },
    selectHotel(pax) {
      if (this.pax.has_cancelled_hotel_voucher && !this.issuedHotel) {
        // Has cancelled hotel voucher
        let lang = this.lang
        this.cancelMessage =
          lang['hotel_mobile_new'].SFS_LANG_ROW_25 ||
          'We are sorry the room was cancelled. For further assistance, please contact the service desk.'
        this.$swal(this.cancelMessage)
        return
      }

      let url = this.PaxsGroup.length > 1 && !this.curPaxId ? '/pax-contact-confirm' : '/hotel-list'
      // Check if is waiting reply from the passenger whom was invited travel together
      url = this.isWaitingInviteReply() ? 'passenger-invite-list' : url
      let reservation_id = pax.reservation_id ? pax.reservation_id : 0
      let voucher_id = pax.voucher_id ? pax.voucher_id : 0
      this.isHandleClickHotel = true
      this.$set(this.urlHotel, 'path', url)
      this.$set(this.urlHotel, 'query', { secret: this.secret, voucher_id: voucher_id, reservation_id: reservation_id })
    },
    isWaitingInviteReply() {
      // Check group waiting reply or not
      let self = this
      return _.some(self.PaxsGroup, function (pax) {
        if (_.isArray(pax.params.travel_together)) {
          return _.some(pax.params.travel_together, function (obj) {
            return obj.confirm_travel_together === '' || (obj.confirm_travel_together === 1 && obj.confirm_manage_book === '')
          })
        }
      })
    },
    checkNumberHotelRoom(service) {
      let self = this
      const hotelService = _.find(service, { service_id: 1 })
      if (!_.isEmpty(hotelService?.params?.matrix_share_room)) {
        const listRoomUnique = _.uniqBy(hotelService.params.matrix_share_room, function (matrix) {
          return matrix.room
        })
        self.numberHotelRoom = listRoomUnique.length || 1
      }
    },
    generateHotelTitle() {
      let self = this
      let serHotel = _.find(self.Services, { service_id: 1 })
      const firstPax = _.find(self.PaxsGroup, (pax) => !self.isInfant(pax)) || null
      self.setDefaultNightBook(firstPax, serHotel)

      if (_.isUndefined(serHotel) || _.isNull(serHotel.params)) {
        return
      }
      self.issuedHotel = false
      if (this.PaxsHotel && this.PaxsHotel.name) {
        // The passenger had issue hotel\
        self.hotelTitle = this.PaxsHotel.name
        self.issuedHotel = true
        // Group by hotel if them share room
        self.groupShareRoom = _.map(
          _.groupBy(serHotel.params.matrix_share_room, function (obj) {
            return obj.room
          }),
          function (obj) {
            let first = self.firstNotInfant(obj)
            let pax = _.find(self.PaxsGroup, { passenger_id: parseInt(first.passenger_id) })
            return {
              passenger_id: first.passenger_id,
              night: pax?.more_night || []
            }
          }
        )
      } else {
        self.groupShareRoom = []
      }
      if (_.isEmpty(self.groupShareRoom)) {
        self.nightPax = firstPax?.more_night || ''
        if (_.isEmpty(self.nightPax)) {
          self.setDefaultNightBook(firstPax, serHotel)
        }
      }
    },
    setDefaultNightBook(pax, serHotel) {
      if (pax?.overnight_date) {
        this.nightPax = [
          {
            blockdate: this.moment(pax.overnight_date).format('DD-MMM-YYYY')
          }
        ]
      }

      if (_.isUndefined(serHotel) || _.isNull(serHotel.params) || _.isEmpty(serHotel.params.hotel_name)) {
        let nights = 1

        if (pax?.overnight_date_end) {
          nights = this.moment(pax.overnight_date_end).diff(this.moment(pax.overnight_date), 'days')
        }

        if (!empty(this.nightPax)) {
          _.first(this.nightPax).blockdate = _.replace(
            this.lang['homepage_new'] && this.lang['homepage_new'].SFS_LANG_ROW_18
              ? this.lang['homepage_new'].SFS_LANG_ROW_18
              : 'for <number_night> night',
            '<number_night>',
            nights
          )
        }
      }
    },
    getPaxInfo() {
      let cur_pax_id = this.pax.curPaxID ? this.pax.curPaxID : this.pax.id
      this.$store.dispatch('Home/getServices', cur_pax_id)

      if (this.PaxsGroup.length == 1) {
        this.curPaxInfo = this.pax
      } else {
        this.curPaxInfo = _.find(this.PaxsGroup, (pax) => {
          if (this.$cookie.get('confirm' + pax.passenger_id)) {
            this.$cookie.set('curPaxID' + this.pax.group_id, pax.passenger_id) //because group id has changed when confirmed pax, we need to update it
            this.pax.curPaxID = pax.passenger_id
            return true
          }
        })
      }
      if (_.isUndefined(this.curPaxInfo) && this.$route.name != 'PaxContactConfirm') {
        this.$router.push({ path: '/pax-contact-confirm', query: { secret: this.secret } })
      }
    },
    isEnabledConfig(key, type = 'homepage_new') {
      let row = _.find(this.airline?.lang_config?.[type]?.CONFIG, { key: key })
      return !_.isUndefined(row) ? row.enabled : false
    },
    callBackPax() {
      this.$store
        .dispatch('getCallBackCustomer', { group_id: this.pax.params.group_id, secret: this.secret })
        .then((response) => {
          if (response.success) {
            // check call back success -> open call
            this.$set(this.curPaxInfo, 'is_call_back', false)
            this.$swal('Action complete.')
          } else {
            this.$swal('Failed')
          }
        })
        .catch((e) => {
          this.$swal('Failed')
        })
    },
    checkTaxiKarhooTrip() {
      let self = this
      let completeTripCount = 0
      self.taxi = _.find(self.Services, { service_id: 4 })
      if (self.taxi && self.taxi.taxi_booking_detail.length > 0) {
        _.each(self.taxi.taxi_booking_detail, function (item) {
          if (item.karhoo && (item.karhoo.status === 'COMPLETED' || item.karhoo.status === 'FAILED')) {
            completeTripCount += 1
          }
        })
        return completeTripCount == self.taxi.taxi_booking_detail.length
      }
      return false
    },
    checkFirstTripCompleted() {
      let self = this
      self.taxi = _.find(self.Services, { service_id: 4 })
      if (self.taxi && self.taxi.taxi_booking_detail.length > 0) {
        let flag = true
        _.each(self.taxi.taxi_booking_detail, function (item) {
          if (item.karhoo && item.karhoo.status !== 'COMPLETED') {
            flag = false
          }
        })
        return flag
      }
      return false
    },
    showError() {
      this.showAlertTop = true
      this.messagesError = 'Please wait for your trip to complete'
      return
    },
    getMatrixShareTaxi(params) {
      if (typeof params.matrix_share_taxi != 'undefined' || params.matrix_share_taxi) {
        return params.matrix_share_taxi
      }
      return []
    },
    getPaxTaxiVoucher(matrix_share_taxi, paxId) {
      let self = this
      let idx = -1
      //get id of passenger's taxi
      matrix_share_taxi.forEach((taxi, index) => {
        if (taxi.find((passenger_id) => passenger_id == paxId)) {
          idx = index
        }
      })
      if (idx == -1) {
        return false
      }
      //find voucher was used in this taxi
      let found = false
      let voucher = null
      matrix_share_taxi[idx].forEach((paxId) => {
        if (found == true) {
          return voucher
        }
        if (self.TaxiVoucher[paxId] && typeof paxId != 'undefined') {
          found = true
          voucher = self.TaxiVoucher[paxId]
        }
      })
      return voucher
    },
    firstNotInfant(obj) {
      let pax = _.find(obj, (pax) => {
        return !pax.isInfant
      })
      return pax
    },
    isInfant(pax) {
      let ssrs = pax.ssrs
      if (!_.isUndefined(ssrs) && pax.invoicing_flag == 'INFT') {
        let invoicing_flag = _.find(ssrs, function (ssr) {
          return ssr.type == 'INFT'
        })
        if (!invoicing_flag) {
          //define ssr object via amadeus
          let infant = {
            type: 'INFT',
            key: '#INFT',
            ssrValue: {}
          }
          ssrs.push(infant)
        }
      }
      let result = _.find(ssrs, function (ssr) {
        return ssr.type == 'INFT'
      })
      if (result) {
        return true
      } else {
        return false
      }
    },
    listenClickVoucher(voucher, index) {
      self.clickVoucher = voucher
      self.indexClickVoucher = index
    }
  }
}
</script>
